
import { Vue, Options } from "vue-class-component";
import { Inject, Prop } from "vue-property-decorator";
import { useStore } from "vuex";

import { Settings } from "@/config";
import { ICreditHistoryService, StripeService } from "@/service";
import {
  ListItem,
  StripeCheckoutModel,
  SubscriptionModel,
  SubscriptionProductModel,
} from "@/model";

import Selectbox from "@/components/controls/Selectbox.vue";

import { StripeCheckout } from "@vue-stripe/vue-stripe";

@Options({
  components: {
    Selectbox,
    StripeCheckout,
  },
})
export default class PurchaseSubscription extends Vue {
  @Prop() subscriptions: Array<SubscriptionModel> = [];

  @Inject("CreditHistoryService") service: ICreditHistoryService;

  public store = useStore();
  public products: Array<SubscriptionProductModel> = [];

  public publishableKey: string = "";
  public payNow: boolean = false;
  public successUrl: string = "";
  public cancelUrl: string = "";
  public sessionId: string;

  public loading: boolean = false;
  hasBasePlan: boolean = false;

  created() {
    this.publishableKey = Settings.PublicKey;
    this.successUrl = window.location.origin + "/success";
    this.cancelUrl = window.location.origin + "/subscriptions";

    this.bindData();
  }

  private bindData() {
    let service = new StripeService();

    let subscribedFields = ([] as Array<ListItem>).concat(
      ...this.subscriptions.map((s) => s.fields)
    );
    service.getSubscriptionProducts().then((response) => {
      this.products = response;

      this.products.forEach((p) => {
        p.disabled = subscribedFields.some((s) => p.field == s.value);
      });

      this.hasBasePlan = this.subscriptions.some((r) => r.isBasePlan);
      if (!this.hasBasePlan) {
        this.products
          .filter((p) => p.isBasePlan)
          .forEach((bp) => {
            bp.selected = true;
          });

        this.purchase();
      }
    });
  }

  public purchase() {
    let lineItems = this.products
      .filter((p) => p.selected)
      .map((p) => {
        return { price: p.price, quantity: 1 };
      });

    let request = new StripeCheckoutModel();
    request.successURL = this.successUrl;
    request.cancelURL = this.cancelUrl;
    request.mode = "subscription";
    request.lineItems = lineItems;

    this.service.createSession(request).then((sessionId) => {
      this.payNow = true;
      this.sessionId = sessionId;

      let total = this.products.filter((p) => p.selected).map(p => p.amount).reduce((prev, next) => prev + next);
       this.store.dispatch("addPurchaseCredits", {
          credits: total,
          amount: total,
        });

      let stripeService = new StripeService();
      stripeService.getCustomer(this.currentUser.email).then((response) => {
        if (response) this.store.dispatch("setStripeId", response.id);
      });

      setTimeout(() => {
        (this.$refs.checkoutRef as any).redirectToCheckout();
      }, 1000);
    });
  }

  public cancel() {
    this.$emit("cancel");
  }

  get currentUser() {
    return this.store.getters.getCurrentUser;
  }
}
